import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  CardImg,
  ButtonGroup,
  Button,
  Row,
  Modal,
  ModalHeader,
  CustomInput,
  InputGroupAddon,
  InputGroupText,
  Input,
  ModalBody,
  InputGroup,
} from 'reactstrap';

import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import {
  colorBlockStlye,
  SelectStyle,
  InputStlye,
  setBackGroundColor,
} from '../style/DigitalAssistantStyle';

import avatars from '../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../propinfo/gallery/index';
import { getGroupID } from '../../../../../helpers/AxiosAPI';
import { ChromePicker } from 'react-color';
import FontsList from './FontsList';
export default function DigitalAssistant({
  isVoucher = false,
  botSettings,integration,
  saveIntegration,
  allProperties,propertyId,
  integrationId,
}) {
  /** Avatar state */
  const [isSelected, setIsSelected] = useState({
    Jenni: false,
    Novi: false,
    Bob: false,
    Sarah: false,
    Wallis: false,
  });
  const [isAivaHide,setIsAivaHide]=useState(integration.isaivaHide ||false);
  const [error, setError] = useState(true);
  const [avatarLink, setAvatarLink] = useState('');
  const [avatarName, setAvatarName] = useState('');
  const [isFooterHide, setIsFooterHide] = useState(botSettings.isFooterHide);
  const [applyPromoCode, setApplyPromoCode] = useState(integration.applyPromoCode);
  const [displayVouchers, setDisplayVouchers] = useState('');
  const [galleryVisible, setGalleryVisible] = useState(false);
  /** other Digital Assistant state */
  const [edit, setEdit] = useState(true);
  const [fontsList,setFontsList]=useState({
    'title':'',
    'subTitle':'',
    'voucherTitle':'',
    'voucherDescription':'',
    'website':'',
    'buttonText':'',
  });
  const [setting, setSetting] = useState(botSettings);
  let [colorSettings, setColorSettings] = useState(botSettings.colours !== undefined ? botSettings.colours :
    {
      'primaryColor': '',
      'buttonColor': '',
      'redeemBar': '',
      'redeemButton': '',
      'redeemButton': '',
      'buttonTextColor': '',
      'redeemTextColor': '',
      'shoppingBar': '',
      'shoppingBarText': '',

    });
  let [iseditMode, setEditMode] = useState({
    'title': false,
    'subTitle': false,
    'arrow': false,
    'primaryColor': false,
    'buttonColor': false,
    'redeemBar': false,
    'redeemButton': false,
    'buttonTextColor': false,
    'redeemTextColor': false,
    'shoppingBar': false,
    'shoppingBarText': false,
  });

  const handleColoursReset = () => { 

    let colours = colorSettings;
    colours.title = 'black';
    colours.subtitle = 'black';
    colours.primaryColor = '#E31B78';
    colours.buttonColor = '#033DA5';
    colours.redeemBar = '#FA8DAB';
    colours.redeemButton = '#F5D2E3';
    colours.buttonTextColor = 'white';
    colours.redeemTextColor = 'black';
    colours.shoppingBar = '#ED187B';
    colours.shoppingBarText = 'white';       
    setColorSettings(colorSettings);
    
    let fontDetails = fontsList;
    fontDetails.title="Helvetica-Bold";
    fontDetails.subTitle="Helvetica";
    fontDetails.voucherTitle="Helvetica";
    fontDetails.voucherDescription="Helvetica";
    fontDetails.website="Helvetica-Bold";
    fontDetails.buttonText="Helvetica";                
    setFontsList(fontDetails);    
    handleSave("Helvetica-Bold");
}


  useEffect(() => {
    if (botSettings) {
      setSetting(botSettings);
      setFontsList(botSettings.fonts);
      setAvatarName(botSettings.name);
      setAvatarLink(botSettings.urls.icon);
      setDisplayVouchers(botSettings.displayVouchers);
      setIsSelected({ ...avatars, [botSettings.name]: true });
    }
  }, [botSettings]);


  useEffect(() => {
    if (setting) {
      setSetting({
        ...setting,
        urls: { ...setting.urls, icon: avatarLink },
      });
    }
  }, [avatarLink]);
  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_BOT_DEMO
      }?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };
  const handleColorChange = (e) => {
    const value = e.target.value;
    setSetting({
      ...setting,
      colours: { ...setting.colours, [e.target.name]: value },
    });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSetting({
      ...setting,
      [e.target.name]: value,
    });
  };

  const handleSave = () => {    
    setting.isFooterHide = isFooterHide;
    setting.colours = colorSettings;
    setting.fonts=fontsList;    
    saveIntegration({ botSetting: setting ,isaivaHide:isAivaHide, applyPromoCode : applyPromoCode});
  };
  const handleAivaChange=(e)=>{    
    setIsAivaHide(e.target.checked);
  }
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setAvatarLink(image.src);
    setSetting({
      ...setting,
      name: image.caption,
    });
  };
  const SetClose = () => {
    setEditMode({
      'title': false,
      'subTitle': false,
      'arrow': false,
      'primaryColor': false,
      'buttonColor': false,
      'redeemBar': false,
      'redeemButton': false,
      'buttonTextColor': false,
      'redeemTextColor': false,
      'shoppingBar': false,
      'shoppingBarText': false,
    });
  };
  const CloseColorBox = (event) => {
    if ((iseditMode.title === true || iseditMode.arrow === true ||
      iseditMode.subTitle === true || iseditMode.primaryColor === true || iseditMode.buttonColor === true || iseditMode.redeemBar === true
      || iseditMode.redeemButton === true || iseditMode.buttonTextColor === true ||
      iseditMode.shoppingBar === true || iseditMode.shoppingBarText === true)) {
      SetClose();

    }
  };
  // const selectAvatar = (name, link) => {
  //   const avatars = {
  //     Jenni: false,
  //     Novi: false,
  //     Bob: false,
  //     Sarah: false,
  //     Wallis: false,
  //   };
  //   setIsSelected({ ...avatars, [name]: true });
  //   setAvatarLink(link);
  //   setAvatarName(name);
  //   setSetting({
  //     ...setting,
  //     name,
  //   });
  // };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const Show = () => {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody onClick={(e) => { CloseColorBox(e); }}>
            <div className="text-center">
              <h6>Choose icon</h6>
              <Separator className="mb-3" />
              <CardImg
                top
                src={botSettings.urls.icon}
                alt="Card image cap"
                className="img-thumbnail border-0 rounded-circle list-thumbnail"
              />
              <div className="my-2 mt-3 text-center"><b> Display Vouchers</b></div>
              <div className="mb-1 text-center">
                <div className='d-flex justify-content-center'>
                  <span className='ml-3'>{setting.displayVouchers === 1 ? "As Per Voucher Order Defined" : "Random Rotation"} </span></div>
              </div>
              <div className="mb-3"></div>
              <Button

                size="xs"
                color="success"
                outline
                style={{ marginTop: '20px' }}
                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Edit
              </Button>
              <Button
                color="success"
                size="xs"
                outline
                style={{ marginTop: '20px', marginLeft: '5px' }}
                onClick={RedirectToDemo}
              >
                Preview
              </Button>
              <p className='mt-2'>Change Edit to change </p>
            </div>
            {features()}
          </CardBody>
        ) : null}
      </Fragment>
    );
  };

  function features() {
    return (<Row className="my-2">
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Button Text Color</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.buttonTextColor = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.buttonTextColor}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.buttonTextColor)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.buttonTextColor && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.buttonTextColor}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.buttonTextColor = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Redeem Text Color</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.redeemTextColor = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.redeemTextColor}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, redeemTextColor: !iseditMode.redeemTextColor });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.redeemTextColor)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.redeemTextColor && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.redeemTextColor}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.redeemTextColor = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className=' col-md-6  text-left' style={{
              marginTop: '0.30rem'
            }}><b>Shopping Bar</b></div>
            < div className='col-md-6' >
              <InputGroup className="">
                <Input
                  className=""
                  type="text"
                  value={colorSettings.shoppingBar}

                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.shoppingBar = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, shoppingBar: !iseditMode.shoppingBar });
                  }} className="color-square" style={setBackGroundColor(colorSettings.shoppingBar)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.shoppingBar && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
              color={colorSettings.shoppingBar}
              name="subTitle"
              onChange={(e) => {
                if (edit) {
                  let colours = colorSettings;
                  colours.shoppingBar = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div></div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className=' col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><b>Shopping Bar Text</b></div>
            < div className='col-md-6 ' >
              <InputGroup className="">
                <Input
                  className=""
                  type="text"
                  value={colorSettings.shoppingBarText}

                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.shoppingBarText = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, shoppingBarText: !iseditMode.shoppingBarText });
                  }} className="color-square" style={setBackGroundColor(colorSettings.shoppingBarText)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.shoppingBarText && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
              color={colorSettings.shoppingBarText}
              name="subTitle"
              onChange={(e) => {
                if (edit) {
                  let colours = colorSettings;
                  colours.shoppingBarText = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div></div>}
      </Colxx>

      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Primary Color</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.primaryColor = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.primaryColor}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.primaryColor)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.primaryColor && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.primaryColor}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.primaryColor = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Button Color</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.buttonColor = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.buttonColor}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.buttonColor)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.buttonColor && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.buttonColor}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.buttonColor = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Redeem Bar</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.redeemBar = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.redeemBar}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, redeemBar: !iseditMode.redeemBar });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.redeemBar)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.redeemBar && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.redeemBar}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.redeemBar = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>
      <Colxx xxs="6">
        <div >
          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
            <div className='col-md-6 text-left' style={{
              marginTop: '0.30rem'
            }}><span className=''><b>Redeem Button</b></span></div>
            <div className='col-md-6'>
              <InputGroup>
                <Input
                  className=""
                  type="text"
                  onChange={(e) => {
                    let colours = colorSettings;
                    colours.redeemButton = e.target.value;
                    setColorSettings({ ...colorSettings, colours: colours });
                  }}
                  value={colorSettings.redeemButton}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText onClick={() => {
                    setEditMode({ ...iseditMode, redeemButton: !iseditMode.redeemButton });
                  }
                  } className="color-square" style={setBackGroundColor(colorSettings.redeemButton)}></InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        {iseditMode.redeemButton && <div className='parent-div'>
          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
            <ChromePicker disableAlpha={true} className='ml-2'
              style={{ width: '240px' }}
              color={colorSettings.redeemButton}
              onChangeComplete={(e) => {

                if (edit) {
                  let colours = colorSettings;
                  colours.redeemButton = e.hex;
                  setColorSettings({ ...colorSettings, colours: colours });
                } else setError(true);
              }
              }
            />
          </div>
        </div>}
      </Colxx>





    </Row>);
  }
  function Edit() {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody onClick={(e) => { CloseColorBox(e); }}>
            <div className="text-center">
              <h6>Digital Assistant</h6>
              <Separator className="mb-3" />
              <CardImg
                top
                src={avatarLink}
                alt="Card image cap"
                className="img-thumbnail border-0 rounded-circle list-thumbnail"
              />

              <div className="mb-1">
                <Button
                  color="success"
                  size="xs"
                  className="mt-1"
                  onClick={togglegallery}
                >
                  Browse Avatars
                </Button>
              </div>

              <div className="my-2 mt-3 text-center"><b> Display Vouchers</b></div>

              <div className="mb-1 text-center">
                <div className='d-flex justify-content-center'>
                  <Input defaultValue={setting.displayVouchers} style={InputStlye} type='select'
                    value={setting.displayVouchers} min='0' max='200' onChange={e => setSetting({ ...setting, displayVouchers: e.target.value })}>
                    <option value="0">Random Rotation</option>
                    <option value="1">As Per Voucher Order Defined</option>
                  </Input>                  </div>
              </div>
              {features()}

              <div className="my-2 mt-3 text-center"><b>Font Settings</b></div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className="mb-1  row ">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Website Font Name </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                        <FontsList InputStlye={SelectStyle} value={fontsList.website} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, website: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                </div>
                                {fontsList !== undefined && <Fragment>
                                    <div className=' col-md-6 '>
                                    <div className="mb-1  row">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Title Font </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={fontsList.title} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, title: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                    <div className="mb-1 row ">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Subtitle Font </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={fontsList.subTitle} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, subTitle: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                    <div className="mb-1 row ">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Button Font </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={fontsList.buttonText} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, buttonText: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                    <div className="mb-1 row ">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1rem' }}>
                                            <b>Voucher Title Font </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={fontsList.voucherTitle} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, voucherTitle: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                    </div>
                                    <div className=' col-md-6 '>
                                    <div className="mb-1 row">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1rem' }}>
                                            <b>Voucher Description Font </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={fontsList.voucherDescription} botSettings={botSettings} setFont={(e) => setFontsList({ ...fontsList, voucherDescription: e.target.value })}></FontsList>
                                        </div>
                                    </div>
                                    </div>
                                </Fragment>}                            
              </div>
              <div className='d-flex justify-content-center my-3'>
                                    <CustomInput
                                        type="checkbox"
                                        id="aivaEnabled"
                                        checked={isAivaHide}
                                        name="aivaEnabled"
                                        onChange={handleAivaChange}
                                        >Replace the eVoucher email from text to "{allProperties.filter((m)=>m.id===propertyId)[0].name}", otherwise shows as "aiva"</CustomInput>
                                </div>
              <div className='d-flex justify-content-center my-3'>
                <CustomInput
                  key="isFooterAiva"
                  type="checkbox"
                  checked={isFooterHide}
                  onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                ><span>Hide "Grow with aiva"</span></CustomInput>
              </div>
              <div className='d-flex justify-content-center my-3'>
                                <CustomInput
                                    key="applyPromoCode"
                                    type="checkbox"
                                    checked={applyPromoCode}
                                    onChange={(e) => e.target.checked === true ? setApplyPromoCode(true) : setApplyPromoCode(false)}
                                ><span>Show "Gift card or promo code" option</span></CustomInput>
                               </div>
              <div className='d-flex justify-content-center my-3'>
                <Button
                  size="xs"
                  color="dark"
                  outline
                  onClick={() => {
                    handleColoursReset();
                  }}
                >
                  Reset to default font and colors
                </Button>
              </div>
              <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                <Button color="primary" size="xs" outline onClick={()=>handleSave(undefined)}>
                  Save
                </Button>
                <Button
                  size="xs"
                  color="dark"
                  outline
                  onClick={() => {
                    setEdit(!edit);
                  }}
                >
                  Cancel
                </Button>
              </ButtonGroup>
            </div>

          </CardBody>
        ) : null}
        {ImageGalleryButton()}
      </Fragment>
    );
  }

  return <Card className="mb-4">{edit ? Edit() : Show()}</Card>;
}
